import { Injectable } from '@angular/core';
import { EnvironmentFieldmapInfoItem } from './select-environment-field-map-modal.component';

@Injectable({ providedIn: 'root' })
export class FieldMapContext {
    studyName: string;
    selectedEnvironments: EnvironmentFieldmapInfoItem[];
    instanceId: number;
    constructor() {
    }
}